import { Injectable } from '@angular/core';

import { UserStatus } from '@app/shared/enums';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  getStatusClass(status: string) {
    switch (status) {
      case UserStatus.active.toString():
        return '-active';
      case UserStatus.activationPending.toString():
        return '-activation-pending';
      case UserStatus.emailPending.toString():
        return '-email-pending';
      case UserStatus.inActive.toString():
        return '-inactive';
      case UserStatus.invitationWithdrawn.toString():
        return '-withdrawn';
    }

    return '';
  }

  getStatusEquivalent(status: string) {
    switch (status) {
      case UserStatus.active.toString():
        return 'Aktiv';
      case UserStatus.activationPending.toString():
        return 'Aktivierung ausstehend';
      case UserStatus.any.toString():
        return 'Beliebiger Status';
      case UserStatus.emailPending.toString():
        return 'E-Mail Bestätigung ausstehend';
      case UserStatus.inActive.toString():
        return 'Inaktiv';
      case UserStatus.invitationWithdrawn.toString():
        return 'Einladung zurückgezogen';
    }
    return '';
  }

  isStatusInactiveOrWithdrawn(status: string) {
    switch (status) {
      case UserStatus.active.toString():
      case UserStatus.activationPending.toString():
      case UserStatus.any.toString():
      case UserStatus.emailPending.toString():
        return false;
      case UserStatus.inActive.toString():
      case UserStatus.invitationWithdrawn.toString():
        return true;
    }
  }
}
